import { useEffect } from 'react';

import { gql, useQuery } from '@zenbusiness/application-commons-graphql';

import { getLessonData } from '../cms';

const lessonsData = getLessonData();

export const GET_LESSONS = gql`
  query GetLessons($accountUuid: UUID!) {
    lessons(accountUuid: $accountUuid) {
        id
        isCompleted
        articles {
          name
          isCompleted
        }
    }
  }
`;

export const useLessonsGridData = (accountUuid, businessEntityUuid) => {
  const { loading, data, refetch } = useQuery(GET_LESSONS, {
    skip: !accountUuid || !businessEntityUuid,
    variables: {
      accountUuid
    }
  });

  useEffect(() => {
    refetch({
      useCache: false
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isLessonInProgress = (lessonName) => {
    const currentLesson = data?.lessons?.find((lesson) => lesson.id === lessonName);
    const isInProgress = currentLesson?.articles.some((article) => article.isCompleted);

    return isInProgress || false;
  };

  const isLessonCompleted = (lessonName) => {
    let complete = false;
    data?.lessons?.forEach((lesson) => {
      if (lesson.id === lessonName) complete = lesson.isCompleted;
    });

    return complete;
  };

  const getNextUrl = (lessonName) => {
    const articleCompletionData = data?.lessons.find(
      (lesson) => lesson.id === lessonName
    )?.articles;

    if (!articleCompletionData) return `/d/company/${businessEntityUuid}/education-studio/lessons/${lessonName}/preview`;

    const articleCompletions = {};
    for (let i = 0; i < articleCompletionData.length; i += 1) {
      articleCompletions[articleCompletionData[i].name] = articleCompletionData[i].isCompleted;
    }

    const nextArticle = lessonsData?.find(
      (lesson) => lesson.url === lessonName
    )?.steps?.find(
      (article) => !articleCompletions[article.url]
    );

    return `/d/company/${businessEntityUuid}/education-studio/lessons/${lessonName}/${nextArticle?.url ?? 'preview'}`;
  };

  const lessons = lessonsData.map((lesson) => ({
    name: lesson.name,
    thumbnail: lesson.thumbnail,
    title: lesson.steps[0].title,
    description: lesson.steps[0].description,
    isInProgress: isLessonInProgress(lesson.url),
    isCompleted: isLessonCompleted(lesson.url),
    nextStepURL: getNextUrl(lesson.url)
  }));

  return { isLoading: loading, lessons };
};
